import moment from 'moment';
import { Workbook } from 'exceljs';

const COLUMN_HEADERS = [
  'N°contrat',
  'Type',
  'Date Effet',
  'Nom',
  'Prénom',
  'Fractionnement',
  'Date résiliation',
  'Adresse',
  'Statut',
  'Frais de courtage',
  'Commission en %',
  'Cotisation en %',
  'Frais de dossier',
  'Rémunération',
  'Numéro Siret'
];

export const downloadGroupStatementExcel = (data) => {
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet('Bordereau Groupement');

  data.headers.forEach((h) => {
    const row = worksheet.addRow([h.title, ...h.values]);
    row.getCell(1).font = { bold: true, size: 13 };
  });
  worksheet.addRow([]);

  data.sections.forEach((section) => {
    const insurerRow = worksheet.addRow([
      'Assureur Conseil',
      section.insurer.name
    ]);
    insurerRow.getCell(1).font = { bold: true };

    const headerRow = worksheet.addRow(COLUMN_HEADERS);
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '0085A3' }
      };
      cell.font = { bold: true, color: { argb: 'FFFFFF' }, size: 11 };
    });

    section.content.forEach((row) => {
      worksheet.addRow([
        row.number,
        row.type,
        row.effective_date
          ? moment(row.effective_date).format('DD-MM-YYYY')
          : '',
        row.last_name,
        row.first_name,
        row.fraction_type,
        row.termination_date
          ? moment(row.termination_date).format('DD-MM-YYYY')
          : '',
        row.address,
        row.status,
        row.broker_fee,
        row.commission_fee,
        row.contribution_adjustment,
        row.paperwork_fee,
        row.remuneration,
        row.siret_number
      ]);
    });

    const totalRow = worksheet.addRow([
      'TOTAL',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      section.total.toFixed(2),
      ''
    ]);
    totalRow.getCell(1).font = { bold: true };
    worksheet.addRow([]);
  });

  const grandTotalRow = worksheet.addRow([
    'TOTAL GÉNÉRAL',
    data.grand_total.toFixed(2)
  ]);
  grandTotalRow.getCell(1).font = { bold: true, size: 12 };

  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Bordereau_Groupement_${data.headers[2]?.values[0] || ''}.xlsx`;
    a.click();
  });
};
